import { SET_SNACKBAR_MESSAGE, CLEAR_SNACKBAR_MESSAGE } from "../actions";

export default function setSnackbarMessage(state = "", action) {
  switch (action.type) {
    case SET_SNACKBAR_MESSAGE:
      return action.payload;
    case CLEAR_SNACKBAR_MESSAGE:
      return "";
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/snackbarMessage.js